import styled from 'styled-components';
import { owcTheme } from 'core/theme/theme.config';

export const StyledTooltipedText = styled.div`
    display: block !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;

    .blue-tooltip-span {
        color: ${owcTheme['one-color-foreground-brand-base']};
    }
`;
